import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../../css/QuickActions.css";
import  PurchaseModal   from "./PurchaseModule";

const QuickActionsSidebar = ({ actions = [], expandedMenu, setExpandedMenu }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [purchaseModal, setPurchaseModal] = useState(false);

  const togglePurchaseModal = () => {
    setPurchaseModal(!purchaseModal);
  };
  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/login";
  };

  const renderAction = (action) => {
    if (action.type === "logout") {
      return (
        <div key="logout" className="sidebar-action-card logout-card" onClick={handleLogout}>
          <div className="sidebar-icon icon-logout">
            <i className="fas fa-sign-out-alt"></i>
          </div>
          <div className="sidebar-action-text">
            <h4>Logout</h4>
            <p>Exit</p>
          </div>
          <div className="sidebar-arrow">
            <i className="fas fa-arrow-right"></i>
          </div>
        </div>
      );
    }

    const handleClick = () => {
      if (action.onClick) {
        action.onClick();
      } else if (action.path) {
        navigate(action.path);
      }
    };

    const isActive = action.activeCheck ? action.activeCheck(location.pathname) : location.pathname === action.path;

    return (
      <div
        key={action.id}
        className={`sidebar-action-card ${isActive ? "active" : ""} ${action.className || ""}`}
        onClick={action.id === "purchase" ? togglePurchaseModal : handleClick}
      >
        <div className={`sidebar-icon ${action.iconClass}`}>
          <i className={action.icon}></i>
        </div>
        <div className="sidebar-action-text">
          <h4>{action.title}</h4>
          <p>{action.subtitle}</p>
        </div>
        <div className="sidebar-arrow">
          <i className="fas fa-arrow-right"></i>
        </div>
      </div>
    );
  };

  return (
    <div className="dashboard-sidebar">
      <div className="sidebar-header">
        <h3>Quick Actions</h3>
      </div>

      <div className="sidebar-actions">
        {actions.map(action => renderAction(action))}
      </div>

      <PurchaseModal isOpen={purchaseModal} toggle={togglePurchaseModal} />
    </div>
  );
};

export default QuickActionsSidebar;
